import React from "react";

const CheckIcon = ({ color = "#1062D0", scale }: { color?: string; scale?: number }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})` }}
    >
      <rect width="24" height="24" rx="12" fill="#EEF5FF" />
      <path
        d="M6.66699 12L10.667 16L17.3337 8"
        stroke={color}
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
